/**
 * Generic sub-tab show/activate helper.
 *
 * @param {string} prefix      - ID prefix for pane elements, e.g. "Payments_" or "" (bare)
 * @param {string} dropdownId  - ID of the dropdown <ul> whose .dropdown-items to update
 * @param {string} tabName     - The tab ID (without prefix), e.g. "Finance"
 */
window.showSubTab = function(prefix, dropdownId, tabName) {
    // Hide all panes in this group.
    // When prefix is non-empty we can use [id^=prefix]; when empty we scope to
    // the nearest .tab-content ancestor of the target pane to avoid matching
    // unrelated panes (browsers treat [id^=""] as matching nothing).
    var targetPane = document.querySelector('#' + prefix + tabName);
    if (!targetPane) return;

    if (prefix) {
        document.querySelectorAll('.tab-pane[id^="' + prefix + '"]').forEach(function(pane) {
            pane.classList.remove('active', 'show');
        });
    } else {
        var container = targetPane.closest('.tab-content');
        if (container) {
            container.querySelectorAll('.tab-pane').forEach(function(pane) {
                pane.classList.remove('active', 'show');
            });
        }
    }

    // Show target pane
    targetPane.classList.add('active', 'show');

    // Update dropdown active state
    document.querySelectorAll('#' + dropdownId + ' .dropdown-item').forEach(function(item) {
        item.classList.remove('active');
    });
    var item = document.querySelector('#dd' + tabName);
    if (item) item.classList.add('active');

    // Persist in URL hash
    history.replaceState(null, '', location.pathname + location.search + '#' + prefix + tabName);
};
